
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import WebVitalsTracker from './components/performance/WebVitalsTracker';
import ResourcePreloader from './components/performance/ResourcePreloader';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ResourcePreloader />
      <WebVitalsTracker />
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
